export default "__VITE_ASSET__CfCEQRMu__"